module.exports = "https://static.wagwalking.com/_next/static/images/pet-10-d7a1c16c758aaabdf54f4a0241edf54e.png";